const WORDS = ["Being found", "Google Search", "Being understood", "AI Overviews", "ChatGPT", "Being trusted", "Gemini", "Perplexity", "Answer engines", "Generative search"];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/10 bg-ink py-7 sm:py-9">
      <div className="marquee-track flex w-max items-center">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className={`whitespace-nowrap px-6 text-3xl sm:px-10 sm:text-5xl ${i % 2 ? "font-display font-medium text-white/90" : "font-serif-i text-violet-300"}`}>{w}</span>
            <span className="h-2 w-2 rotate-45 bg-violet-500/70" />
          </span>
        ))}
      </div>
    </div>
  );
};
